module.exports = __webpack_public_path__ + "static/media/rick_morty.ce5cf497.jpg";